import React from "react";
import * as S from "./PremiumLoadingStyle";
import {
  FiDatabase,
  FiShield,
  FiTrendingUp,
  FiCheckCircle,
  FiLoader,
} from "react-icons/fi";

const getIconForMessage = (message) => {
  const lowerMessage = message.toLowerCase();
  if (lowerMessage.includes("contrato")) return <FiTrendingUp />;
  if (lowerMessage.includes("saque")) return <FiTrendingUp />;
  if (lowerMessage.includes("plataforma")) return <FiDatabase />;
  if (lowerMessage.includes("extrato")) return <FiDatabase />;
  if (lowerMessage.includes("pronto") || lowerMessage.includes("bem-vindo"))
    return <FiCheckCircle />;
  if (
    lowerMessage.includes("credenciais") ||
    lowerMessage.includes("segurança")
  )
    return <FiShield />;
  return <FiLoader />;
};

const PremiumLoadingScreen = ({
  isLoading,
  isDataLoaded,
  progress,
  message,
}) => {
  if (!isLoading) return null;

  const icon = getIconForMessage(message);

  return (
    <S.LoadingOverlay>
      <S.LoadingContainer>
        <S.Logo src="/logo-golden.png" alt="Golden Brasil" />
        <S.IconWrapper key={message}>{icon}</S.IconWrapper>
        <S.LoadingText>{message}</S.LoadingText>
        <S.ProgressBarContainer>
          <S.ProgressBarFiller style={{ width: `${progress}%` }} />
        </S.ProgressBarContainer>
        <S.ProgressText>{progress}%</S.ProgressText>
      </S.LoadingContainer>
    </S.LoadingOverlay>
  );
};

export default PremiumLoadingScreen;
